<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card>
      <!-- <b-card-text>Privilege.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <b-col cols="12" xl="6">
              <div class="d-flex align-items-center mt-1">
                <feather-icon icon="UserIcon" size="18"/>
                <h4 class="mb-0 ml-75">Data Pengguna</h4>
              </div>
              <!-- Pengguna -->
              <div class="mt-2">
                <h5 class="text-capitalize mb-75">Pengguna</h5>
                <b-card-text>{{ name }}</b-card-text>
              </div>
              <!-- Nama Lengkap -->
              <div class="mt-2">
                <h5 class="text-capitalize mb-75">Nama Lengkap</h5>
                <b-card-text>{{ fullname }}</b-card-text>
              </div>
              <!-- KTP -->
              <div class="mt-2">
                <h5 class="text-capitalize mb-75">KTP</h5>
                <b-card-text>{{ id_card_number }}</b-card-text>
              </div>
              <!-- Email -->
              <div class="mt-2">
                <h5 class="text-capitalize mb-75">Email</h5>
                <b-card-text>{{ email }}</b-card-text>
              </div>
              <!-- No. HP -->
              <div class="mt-2">
                <h5 class="text-capitalize mb-75">No. HP</h5>
                <b-card-text>{{ phone }}</b-card-text>
              </div>
              <!-- Alamat -->
              <div class="mt-2">
                <h5 class="text-capitalize mb-75">Alamat</h5>
                <b-card-text>{{ address }}</b-card-text>
              </div>
              <!-- Waktu Akses Terkahir -->
              <div class="mt-2">
                <h5 class="text-capitalize mb-75">Waktu Akses Terkahir</h5>
                <b-card-text>{{ last_phone_access }}</b-card-text>
              </div>
            </b-col>
            <b-col cols="12" xl="6">
              <div class="d-flex align-items-center mt-1">
                <!-- <feather-icon icon="UserIcon" size="18"/> -->
                <h4 class="mb-0 ml-75">&nbsp;</h4>
              </div>
              <!-- ID -->
              <div class="mt-2">
                <h5 class="text-capitalize mb-75">Foto KTP</h5>
                <!-- <b-card-text>{{ photo }}</b-card-text> -->
                <div class="profile-img">
                  <b-img :src="id_card_photo" rounded fluid alt="profile photo" referrerpolicy="no-referrer" />
                </div>
              </div>
              <!-- Foto -->
              <div class="mt-2">
                <h5 class="text-capitalize mb-75">Foto</h5>
                <!-- <b-card-text>{{ photo }}</b-card-text> -->
                <div class="profile-img">
                  <b-img :src="photo" rounded fluid alt="profile photo" referrerpolicy="no-referrer" />
                </div>
              </div>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Verifikasi </b-button>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="warning" class="mr-1" @click.prevent="validationFormReject"> Reject </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BImg, BCardText, BRow, BOverlay, BCol, BFormGroup, BFormInput, BForm, BButton, BCard } from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { BImg, BCardText, vSelect, BOverlay, ValidationProvider, ValidationObserver, BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      id: null, name:'', fullname:'', id_card_number:'', email:'', phone:'', address:'', last_phone_access:'', photo:'',id_card_photo:'',
      show: false,
      required 
    }
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = {id: this.id, url: 'accept'} 
			    this.$store.dispatch('verification/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    validationFormReject () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = {id: this.id, url: 'reject'} 
			    this.$store.dispatch('verification/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('verification/getById', id).then(data => {
        this.id = data.user_id
        this.is_verified = data.is_verified
        this.name = data.name
        this.fullname = data.fullname
        this.id_card_number = data.id_card_number
        this.email = data.email
        this.phone = data.phone
        this.address = data.address
        this.last_phone_access = data.last_phone_access
        this.photo = data.photo
        this.id_card_photo = data.id_card_photo
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>